import { render, staticRenderFns } from "./restoreDeleting.vue?vue&type=template&id=0325999c"
import script from "./restoreDeleting.vue?vue&type=script&lang=js"
export * from "./restoreDeleting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports